import { render, staticRenderFns } from "./dynamicChart.vue?vue&type=template&id=1044d1d8&scoped=true&lang=pug"
import script from "./dynamicChart.vue?vue&type=script&lang=js"
export * from "./dynamicChart.vue?vue&type=script&lang=js"
import style0 from "./dynamicChart.vue?vue&type=style&index=0&id=1044d1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044d1d8",
  null
  
)

export default component.exports